import dayjs from "dayjs";
const getDurationInMs = (date1, date2) => {
  const d1 = dayjs(date1);
  const d2 = dayjs(date2);
  return Math.abs(d1.diff(d2));
};
var getDurationInMs_default = getDurationInMs;
export {
  getDurationInMs_default as default
};
